import { render, staticRenderFns } from "./metadata-publish.vue?vue&type=template&id=2831a1cc&scoped=true&"
import script from "./metadata-publish.vue?vue&type=script&lang=js&"
export * from "./metadata-publish.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2831a1cc",
  null
  
)

export default component.exports